<template>
  <div>
    <el-page-header @back="clickHeaderBack" :content="titleStr"></el-page-header>
  </div>
</template>

<script>
export default {
  name: "AppPageHeader",
  
  data() {
    return {
      title: ""
    };
  },
  
  computed: {
    titleStr() {
      let subt = " ";
      let str = this.$route.name;
      if (subt) {
        str += subt;
      }
      return str;
    }
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    clickHeaderBack() {
      this.$router.back();
      this.$router.push("/");
    }
  },
  
  watch: {
    $route: {
      handler(route) {
        this.title = route.name;
        // console.log("onRouteChange");
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
